module.exports = __webpack_public_path__ + "img/logo.cd94145c.png";